import React, { useState } from "react";
import { cancelAppointmentPatient } from "../APIs/patientAppointmentApi";

function fmtTime(iso) {
  try {
    const clean = String(iso).split("[")[0];
    return new Date(clean).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso ?? "";
  }
}

function fmtDate(iso) {
  try {
    const clean = String(iso).split("[")[0];
    return new Date(clean).toLocaleDateString([], {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return iso ?? "";
  }
}

export default function AppointmentConflictModal({
  conflicts,
  patientId,
  onGoBack,
  onCancelAndProceed,
  proceeding,
}) {
  const [cancellingId, setCancellingId] = useState(null);
  const [error, setError] = useState("");

  const handleCancelAndProceed = async (conflict) => {
    setCancellingId(conflict.appointmentId);
    setError("");
    try {
      await cancelAppointmentPatient({
        appointmentId: conflict.appointmentId,
        patientId,
        reason: "Rescheduled due to booking conflict",
      });
      onCancelAndProceed(conflict.appointmentId);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to cancel appointment",
      );
      setCancellingId(null);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4">
        <div className="p-5 border-b">
          <h2 className="text-lg font-semibold text-red-700">
            Scheduling Conflict
          </h2>
          <p className="text-sm text-gray-600 mt-1">
            You already have an appointment at this time. Choose how to proceed.
          </p>
        </div>

        <div className="p-5 space-y-3">
          {conflicts.map((c) => (
            <div
              key={c.appointmentId}
              className="p-3 border rounded-lg bg-red-50 border-red-200 space-y-2"
            >
              <div className="text-sm font-medium text-gray-800">
                {c.providerName}
              </div>
              <div className="text-xs text-gray-600">
                {fmtDate(c.appointmentStart)} &middot;{" "}
                {fmtTime(c.appointmentStart)} &ndash;{" "}
                {fmtTime(c.appointmentEnd)}
              </div>
              <button
                disabled={cancellingId === c.appointmentId || proceeding}
                onClick={() => handleCancelAndProceed(c)}
                className="w-full mt-1 px-3 py-1.5 text-sm rounded bg-red-600 text-white hover:bg-red-700 disabled:opacity-50"
              >
                {cancellingId === c.appointmentId
                  ? "Cancelling..."
                  : `Cancel ${c.providerName} & Continue`}
              </button>
            </div>
          ))}

          {error && <p className="text-sm text-red-600">{error}</p>}
        </div>

        <div className="flex justify-end px-5 py-4 border-t bg-gray-50">
          <button
            onClick={onGoBack}
            disabled={!!cancellingId || proceeding}
            className="px-4 py-2 text-sm rounded border hover:bg-gray-100 disabled:opacity-50"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
